import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import Paper from '@material-ui/core/Paper'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import TableBody from '@material-ui/core/TableBody'
import TableFooter from '@material-ui/core/TableFooter'
import TablePagination from '@material-ui/core/TablePagination'
import IconButton from '@material-ui/core/IconButton'
import Checkbox from '@material-ui/core/Checkbox'
import EditIcon from '@material-ui/icons/Edit'
import LockIcon from '@material-ui/icons/Lock'
import HistoryIcon from '@material-ui/icons/History'
import SkeletonTable from '../../../common/skeleton-table'
import Y from '../../../y18n'
import TableToolbar from '../../../common/table-toolbar'
import * as userActions from '../../../store/users'
import Styles from '../../../common/styles'
import CountriesDropdown from '../../../common/dropdowns/countries-dropdown'

const mapStateToProps = state => ({
  users: state.users
})

const mapDispatchToProps = dispatch => ({
  userActions: bindActionCreators(userActions, dispatch)
})

class UsersTable extends Component {
  componentDidMount () {
    this.props.userActions.getUsers()
  }

  componentWillUnmount () {
    this.props.userActions.clearUsers()
  }

  handleLanguageFilterChange = event => {
    const value = event.target.value

    this.props.userActions.setFilter('country', value)
  }

  filterUsers = users => {
    const countryFilter = users.filter.country

    if (!countryFilter) return users

    const items = users.items.filter(u => u.country === countryFilter)
    const itemCount = items.length

    return { ...users, items, itemCount }
  }

  confirmDialog = (message, proceed, abort, item) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className='react-confirm-alert-body'>
            <h1>{Y`Confirm`}</h1>
            <p>{message}</p>
            <br/>
            <p>{Y`Do you want to proceed`}</p>
            <div className={this.props.classes.reactConfirmButtonGroup}>
              <button 
                className={this.props.classes.reactConfirmButtonGroupBtnNeutral}
                onClick={() => {
                  if(item)
                    abort(item)
                  else
                    abort()
                  onClose()
                }}>{Y`Cancel`}
              </button>
              <button
                className={this.props.classes.reactConfirmButtonGroupBtnWarning}
                onClick={() => {
                  if(item)
                    proceed(item)
                  else
                    proceed()
                  onClose()
                }}
              >
              {Y`Ok`}
              </button>
            </div>
          </div>
        )
      }
    })
  }

  render () {
    const { users: unfilteredUsers, userActions, classes } = this.props

    const users = this.filterUsers(unfilteredUsers)

    return (
      <Paper>
        <TableToolbar store={users} storeActions={userActions} title={Y`Users`} />
        <div style={{ paddingLeft: 24, paddingRight: 24 }}>
          <CountriesDropdown
            value={users.filter.country}
            handleChange={this.handleLanguageFilterChange}
            alwaysShowDefaultOption
          />
        </div>
        <div className={classes.tableWrapper}>

          <Table className={'striped'}>
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>
                  <TableSortLabel
                    active={users.sort.orderBy === 'fullName'}
                    direction={users.sort.direction}
                    onClick={this.handleSortChange('fullName')}
                  >
                    {Y`Name`}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={users.sort.orderBy === 'email'}
                    direction={users.sort.direction}
                    onClick={this.handleSortChange('email')}
                  >
                    {Y`Email`}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={users.sort.orderBy === 'phoneNumber'}
                    direction={users.sort.direction}
                    onClick={this.handleSortChange('phoneNumber')}
                  >
                    {Y`Phone number`}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={users.sort.orderBy === 'fullAddress'}
                    direction={users.sort.direction}
                    onClick={this.handleSortChange('fullAddress')}
                  >
                    {Y`Address`}
                  </TableSortLabel>
                </TableCell>
                <TableCell>
                  <TableSortLabel
                    active={users.sort.orderBy === 'country'}
                    direction={users.sort.direction}
                    onClick={this.handleSortChange('country')}
                  >
                    {Y`Country`}
                  </TableSortLabel>
                </TableCell>
                <TableCell padding='checkbox'>
                  <Checkbox
                    checked={users.allSelected}
                    onChange={() => this.handleCheckAll()}
                    classes={{ checked: classes.checked }}
                  />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.loading
                ? <SkeletonTable rows={users.rowsPerPage} cols={7} />
                : users.sort.direction === 'desc'
                    ? users.items
                        .sort((a, b) => (b[users.sort.orderBy] <= a[users.sort.orderBy] ? -1 : 1))
                        .slice(users.page * users.rowsPerPage, users.page * users.rowsPerPage + users.rowsPerPage)
                        .map(user => this.renderUser(user))
                    : users.items
                        .sort((a, b) => (a[users.sort.orderBy] <= b[users.sort.orderBy] ? -1 : 1))
                        .slice(users.page * users.rowsPerPage, users.page * users.rowsPerPage + users.rowsPerPage)
                        .map(user => this.renderUser(user))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={users.itemCount}
                  rowsPerPage={users.rowsPerPage}
                  page={users.page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </Paper>
    )
  }

  renderUser (user) {
    return (
      <TableRow key={user.id} role='checkbox' aria-checked={user.checked}>
        <TableCell>
          <IconButton title={Y`Edit user`} onClick={() => this.props.userActions.setActive(user)}>
            <EditIcon />
          </IconButton>
          <IconButton
            title={Y`Set temporary password for user`}
            onClick={() => this.props.userActions.setTempPassword(true, user.id)}
          >
            <LockIcon />
          </IconButton>
          <IconButton title={Y`View user events`} onClick={() => this.props.userActions.viewHistory(user)}>
            <HistoryIcon />
          </IconButton>
        </TableCell>
        <TableCell>
          {user.fullName}
          {' '}
          {user.role === 'Admin'
            ? <span title={Y`Admin`} style={{ cursor: 'pointer' }}>*</span>
            : user.role === 'SuperAdmin'
                ? <span title={Y`SuperAdmin`} style={{ cursor: 'pointer' }}>
                    **
                  </span>
                : ''}
        </TableCell>
        <TableCell>
          {!user.emailVerified
            ? <span title={Y`Email has not been verified`} style={{ color: 'red', cursor: 'pointer' }}>
              {user.email}
            </span>
            : <span>{user.email}</span>}
        </TableCell>
        <TableCell>{user.phoneNumber}</TableCell>
        <TableCell>{user.fullAddress}</TableCell>
        <TableCell>{Y`${user.country}`}</TableCell>
        <TableCell padding='checkbox'>
          <Checkbox
            checked={user.checked}
            onChange={() => this.handleCheck(user)}
            classes={{ checked: this.props.classes.checked }}
          />
        </TableCell>
      </TableRow>
    )
  }

  handleCheckAll = checked => {
    if(this.props.users.selectedItems.length === 0)
      this.confirmDialog(Y`You're about to select multiple users for deletion. All isolated details about these users will be permanently removed from all logs, filed and other records were it's possible. You'll still need to press the delete buttom.`,
      () => {this.props.userActions.toggleAll(this.props.users.allSelected)},
      () => {})
    else
      this.props.userActions.toggleAll(this.props.users.allSelected)
  }

  handleCheck = item => {
    if(!item.checked){
      this.confirmDialog(Y`You're about to select a user for deletion. All isolated details about the user will be permanently removed from all logs, files and other records were it's possible. You'll still need to press the delete button.`,
      this.props.userActions.selectItem,
      () => {},
      item)
    }
    else
      this.props.userActions.unselectItem(item)

    //item.checked ? this.props.userActions.unselectItem(item) : this.props.userActions.selectItem(item)
  }

  handleSortChange = value => event => {
    this.props.userActions.setSort(value)
  }

  handleChangePage = (event, page) => {
    this.props.userActions.setPage(page)
    this.props.userActions.getUsers()
  }

  handleChangeRowsPerPage = event => {
    this.props.userActions.setRowsPerPage(event.target.value)
    this.props.userActions.getUsers()
  }

  handleFilterChange = filterType => e => {
    let filter = { ...this.props.users.filter }
    filter[filterType] = e.target.value
    this.props.userActions.setFilter(filterType, e.target.value)
  }
}

UsersTable = connect(mapStateToProps, mapDispatchToProps)(UsersTable)
export default withStyles(Styles)(UsersTable)



// WEBPACK FOOTER //
// ./src/pages/users/containers/users-table.js